export default [
	'.Property.Activities.Entertainment.Water park',
	'.Property.Activities.Entertainment.Billiards',
	'.Property.Activities.Entertainment.Bowling',
	'.Property.Activities.Entertainment.Casino',
	'.Property.Activities.Entertainment.Playground',
	'.Property.Activities.Entertainment.Darts',
	'.Property.Activities.Entertainment.Evening entertainment',
	'.Property.Activities.Entertainment.Game room',
	'.Property.Activities.Entertainment.Karaoke',
	'.Property.Activities.Entertainment.Kids\' club',
	'.Property.Activities.Entertainment.Nightclub/DJ',
	'.Property.Activities.Entertainment.Other Entertainment',
	'.Property.Activities.Sports.Canoeing',
	'.Property.Activities.Sports.Biking',
	'.Property.Activities.Sports.Diving',
	'.Property.Activities.Sports.Fishing',
	'.Property.Activities.Sports.Golf course',
	'.Property.Activities.Sports.Hiking',
	'.Property.Activities.Sports.Horseback riding',
	'.Property.Activities.Sports.Mini Golf',
	'.Property.Activities.Sports.Ski school',
	'.Property.Activities.Sports.Skiing',
	'.Property.Activities.Sports.Snorkeling',
	'.Property.Activities.Sports.Squash',
	'.Property.Activities.Sports.Ping-pong',
	'.Property.Activities.Sports.Tennis court',
	'.Property.Activities.Sports.Windsurfing',
	'.Property.Activities.Sports.Other Sports',
	'.Property.Activities.Other Activities',
	'.Property.Animals.Pets',
	'.Property.Animals.Other Animals',
	'.Property.Area and facilities.Business facilities.Meeting/conference room',
	'.Property.Area and facilities.Business facilities.Other Business facilities',
	'.Property.Area and facilities.Spa and wellness facilities.Hot springs',
	'.Property.Area and facilities.Spa and wellness facilities.Hot tub',
	'.Property.Area and facilities.Spa and wellness facilities.Massage',
	'.Property.Area and facilities.Spa and wellness facilities.Open-air bath',
	'.Property.Area and facilities.Spa and wellness facilities.Bathhouse',
	'.Property.Area and facilities.Spa and wellness facilities.Sauna',
	'.Property.Area and facilities.Spa and wellness facilities.Tanning salon',
	'.Property.Area and facilities.Spa and wellness facilities.Steam room',
	'.Property.Area and facilities.Spa and wellness facilities.Other Spa and wellness facilities',
	'.Property.Area and facilities.BBQ facilities',
	'.Property.Area and facilities.Balcony, terrace or patio',
	'.Property.Area and facilities.Banquet facilities',
	'.Property.Area and facilities.Beach',
	'.Property.Area and facilities.Communal kitchen',
	'.Property.Area and facilities.Communal lounge/TV room',
	'.Property.Area and facilities.Facilities for Disabled Guests',
	'.Property.Area and facilities.Fitness center',
	'.Property.Area and facilities.Garden',
	'.Property.Area and facilities.Library',
	'.Property.Area and facilities.Lobby or front desk',
	'.Property.Area and facilities.Lounge or bar',
	'.Property.Area and facilities.On-site stores',
	'.Property.Area and facilities.Patio',
	'.Property.Area and facilities.Place of worship',
	'.Property.Area and facilities.Restaurant/places to eat',
	'.Property.Area and facilities.Swimming pool',
	'.Property.Area and facilities.Other Area and facilities',
	'.Property.Food & drink.Drinks.Alcoholic drinks',
	'.Property.Food & drink.Drinks.Non-alcoholic drinks',
	'.Property.Food & drink.Drinks.Other Drinks',
	'.Property.Food & drink.Food.Meals.Breakfast.American breakfast',
	'.Property.Food & drink.Food.Meals.Breakfast.Asian breakfast',
	'.Property.Food & drink.Food.Meals.Breakfast.Buffet breakfast',
	'.Property.Food & drink.Food.Meals.Breakfast.Continental breakfast',
	'.Property.Food & drink.Food.Meals.Breakfast.English/Irish breakfast',
	'.Property.Food & drink.Food.Meals.Breakfast.Italian breakfast',
	'.Property.Food & drink.Food.Meals.Breakfast.Other Breakfast',
	'.Property.Food & drink.Food.Meals.Dinner',
	'.Property.Food & drink.Food.Meals.Lunch',
	'.Property.Food & drink.Food.Meals.Other Meals',
	'.Property.Food & drink.Food.Food close-up',
	'.Property.Food & drink.Food.Other Food',
	'.Property.Food & drink.Other Food & drink',
	'.Property.Logo, certificate or sign.Certificate/award',
	'.Property.Logo, certificate or sign.Property logo or sign',
	'.Property.Logo, certificate or sign.Caption',
	'.Property.Logo, certificate or sign.Other Logo, certificate or sign',
	'.Property.People.Guests.Children.Older children',
	'.Property.People.Guests.Children.Young children',
	'.Property.People.Guests.Children.Other Children',
	'.Property.People.Guests.Group of guests',
	'.Property.People.Guests.Other Guests',
	'.Property.People.Family',
	'.Property.People.Staff',
	'.Property.People.Other People',
	'.Property.Property building.Bird\'s-eye view',
	'.Property.Property building.Facade/entrance',
	'.Property.Property building.Floor plan',
	'.Property.Property building.Other Property building',
	'.Property.View.City view',
	'.Property.View.Garden view',
	'.Property.View.Lake view',
	'.Property.View.Landmark view',
	'.Property.View.Mountain view',
	'.Property.View.Pool view',
	'.Property.View.River view',
	'.Property.View.Sea view',
	'.Property.View.Street view',
	'.Property.View.Other View',
	'.Property.Decorative detail',
	'.Property.Other',
	'.Room.Animals.Pets',
	'.Room.Animals.Other Animals',
	'.Room.Area and facilities.Spa and wellness facilities.Hot springs',
	'.Room.Area and facilities.Spa and wellness facilities.Hot tub',
	'.Room.Area and facilities.Spa and wellness facilities.Massage',
	'.Room.Area and facilities.Spa and wellness facilities.Open-air bath',
	'.Room.Area and facilities.Spa and wellness facilities.Bathhouse',
	'.Room.Area and facilities.Spa and wellness facilities.Sauna',
	'.Room.Area and facilities.Spa and wellness facilities.Other Spa and wellness facilities',
	'.Room.Area and facilities.BBQ facilities',
	'.Room.Area and facilities.Balcony, terrace or patio',
	'.Room.Area and facilities.Bathtub',
	'.Room.Area and facilities.Bathroom',
	'.Room.Area and facilities.Bedroom',
	'.Room.Area and facilities.Coffee/tea facilities',
	'.Room.Area and facilities.Dining area',
	'.Room.Area and facilities.Fitness center',
	'.Room.Area and facilities.Garden',
	'.Room.Area and facilities.Kitchen or Kitchenette',
	'.Room.Area and facilities.Library',
	'.Room.Area and facilities.Living room',
	'.Room.Area and facilities.Patio',
	'.Room.Area and facilities.Sitting area',
	'.Room.Area and facilities.Shower',
	'.Room.Area and facilities.Swimming pool',
	'.Room.Area and facilities.TV and multimedia',
	'.Room.Area and facilities.Toilet',
	'.Room.Area and facilities.Other Area and facilities',
	'.Room.Bed.Bunk bed',
	'.Room.Bed.Crib',
	'.Room.Bed.Other Bed',
	'.Room.Food & drink.Drinks.Alcoholic drinks',
	'.Room.Food & drink.Drinks.Non-alcoholic drinks',
	'.Room.Food & drink.Drinks.Other Drinks',
	'.Room.Food & drink.Food.Meals.Breakfast.American breakfast',
	'.Room.Food & drink.Food.Meals.Breakfast.Asian breakfast',
	'.Room.Food & drink.Food.Meals.Breakfast.Buffet breakfast',
	'.Room.Food & drink.Food.Meals.Breakfast.Continental breakfast',
	'.Room.Food & drink.Food.Meals.Breakfast.English/Irish breakfast',
	'.Room.Food & drink.Food.Meals.Breakfast.Italian breakfast',
	'.Room.Food & drink.Food.Meals.Breakfast.Other Breakfast',
	'.Room.Food & drink.Food.Meals.Dinner',
	'.Room.Food & drink.Food.Meals.Lunch',
	'.Room.Food & drink.Food.Meals.Other Meals',
	'.Room.Food & drink.Food.Food close-up',
	'.Room.Food & drink.Food.Other Food',
	'.Room.Food & drink.Other Food & drink',
	'.Room.Logo, certificate or sign.Certificate/award',
	'.Room.Logo, certificate or sign.Property logo or sign',
	'.Room.Logo, certificate or sign.Caption',
	'.Room.Logo, certificate or sign.Other Logo, certificate or sign',
	'.Room.People.Guests.Children.Older children',
	'.Room.People.Guests.Children.Young children',
	'.Room.People.Guests.Children.Other Children',
	'.Room.People.Guests.Group of guests',
	'.Room.People.Guests.Other Guests',
	'.Room.People.Family',
	'.Room.People.Staff',
	'.Room.People.Other People',
	'.Room.View.City view',
	'.Room.View.Garden view',
	'.Room.View.Inner courtyard view',
	'.Room.View.Lake view',
	'.Room.View.Landmark view',
	'.Room.View.Mountain view',
	'.Room.View.Pool view',
	'.Room.View.Quiet street view',
	'.Room.View.River view',
	'.Room.View.Sea view',
	'.Room.View.Street view',
	'.Room.View.Other View',
	'.Room.Decorative detail',
	'.Room.Photo of the whole room',
	'.Room.Other',
	'.Surrounding Area.Activities.Entertainment.Water park',
	'.Surrounding Area.Activities.Entertainment.Billiards',
	'.Surrounding Area.Activities.Entertainment.Bowling',
	'.Surrounding Area.Activities.Entertainment.Casino',
	'.Surrounding Area.Activities.Entertainment.Playground',
	'.Surrounding Area.Activities.Entertainment.Darts',
	'.Surrounding Area.Activities.Entertainment.Evening entertainment',
	'.Surrounding Area.Activities.Entertainment.Game room',
	'.Surrounding Area.Activities.Entertainment.Karaoke',
	'.Surrounding Area.Activities.Entertainment.Kids\' club',
	'.Surrounding Area.Activities.Entertainment.Nightclub/DJ',
	'.Surrounding Area.Activities.Entertainment.Other Entertainment',
	'.Surrounding Area.Activities.Sports.Canoeing',
	'.Surrounding Area.Activities.Sports.Biking',
	'.Surrounding Area.Activities.Sports.Diving',
	'.Surrounding Area.Activities.Sports.Fishing',
	'.Surrounding Area.Activities.Sports.Golf course',
	'.Surrounding Area.Activities.Sports.Hiking',
	'.Surrounding Area.Activities.Sports.Horseback riding',
	'.Surrounding Area.Activities.Sports.Mini Golf',
	'.Surrounding Area.Activities.Sports.Ski school',
	'.Surrounding Area.Activities.Sports.Skiing',
	'.Surrounding Area.Activities.Sports.Snorkeling',
	'.Surrounding Area.Activities.Sports.Squash',
	'.Surrounding Area.Activities.Sports.Ping-pong',
	'.Surrounding Area.Activities.Sports.Tennis court',
	'.Surrounding Area.Activities.Sports.Windsurfing',
	'.Surrounding Area.Activities.Sports.Other Sports',
	'.Surrounding Area.Activities.Other Activities',
	'.Surrounding Area.Animals.Pets',
	'.Surrounding Area.Animals.Other Animals',
	'.Surrounding Area.Area and facilities.Spa and wellness facilities.Open-air bath',
	'.Surrounding Area.Area and facilities.Spa and wellness facilities.Bathhouse',
	'.Surrounding Area.Area and facilities.Spa and wellness facilities.Other Spa and wellness facilities',
	'.Surrounding Area.Area and facilities.Beach',
	'.Surrounding Area.Area and facilities.Fitness center',
	'.Surrounding Area.Area and facilities.Natural landscape',
	'.Surrounding Area.Area and facilities.Nearby landmark',
	'.Surrounding Area.Area and facilities.Neighborhood',
	'.Surrounding Area.Area and facilities.Restaurant/places to eat',
	'.Surrounding Area.Area and facilities.Shopping area',
	'.Surrounding Area.Area and facilities.Grocery store/supermarket',
	'.Surrounding Area.Area and facilities.Swimming pool',
	'.Surrounding Area.Area and facilities.Other Area and facilities',
	'.Surrounding Area.Logo, certificate or sign.Certificate/award',
	'.Surrounding Area.Logo, certificate or sign.Property logo or sign',
	'.Surrounding Area.Logo, certificate or sign.Caption',
	'.Surrounding Area.Logo, certificate or sign.Other Logo, certificate or sign',
	'.Surrounding Area.People.Guests.Children.Older children',
	'.Surrounding Area.People.Guests.Children.Young children',
	'.Surrounding Area.People.Guests.Children.Other Children',
	'.Surrounding Area.People.Guests.Group of guests',
	'.Surrounding Area.People.Guests.Other Guests',
	'.Surrounding Area.People.Family',
	'.Surrounding Area.People.Staff',
	'.Surrounding Area.People.Other People',
	'.Surrounding Area.Other',
	'.Features.Location.Off site',
	'.Features.Location.On site',
	'.Features.Location.Other Location',
	'.Features.Seasons.Fall',
	'.Features.Seasons.Spring',
	'.Features.Seasons.Summer',
	'.Features.Seasons.Winter',
	'.Features.Seasons.Other Seasons',
	'.Features.Time of day.Day',
	'.Features.Time of day.Night',
	'.Features.Time of day.Sunrise',
	'.Features.Time of day.Sunset',
	'.Features.Time of day.Other Time of day'
];
